import {
  ILineItem,
  ILineItemsTotal,
  IMonthlyDisable,
  IMonthlySpendData,
  ISpendLineItemSummary,
} from '../../store/spend/spend.interfaces';

export const defaultMonthlyData: IMonthlySpendData = {
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
};

export const defaultMonthlyDisable: IMonthlyDisable = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  7: false,
  8: false,
  9: false,
  10: false,
  11: false,
  12: false,
};

export enum DISTRIBUTION_TYPES {
  BELL_CURVE = 'bell_curve',
  SPLIT_BELL_CURVE = 'split_bell_curve',
  S_CURVE = 's_curve',
  REVERSE_S_CURVE = 'reverse_s_curve',
  STRAIGHT_LINE = 'straight_line',
  STRAIGHT_INCLINE = 'straight_incline',
  STRAIGHT_DECLINE = 'straight_decline',
  MANUAL = 'manual',
}

export const defaultLineItem: ILineItem = {
  id: undefined,
  name: 'Project Cost',
  value: null,
  project_id: undefined,
  start_date: undefined,
  duration: 1,
  distribution: DISTRIBUTION_TYPES.BELL_CURVE,
  prime_start_date: undefined,
  prime_duration: 1,
  prime_distribution: DISTRIBUTION_TYPES.BELL_CURVE,
  budget: [],
  commitment_start_date: null,
  row_number: 1,
  committed_items: [],
  subitems: [],
  used_in_pc: false,
  // monthly_data: { ...defaultMonthlyData }
};

export const defaultLineItemsTotal: ILineItemsTotal = {
  project_total: 0,
  year_total: 0,
  monthly_data: { ...defaultMonthlyData },
};

export const distributionTypes = [
  {
    key: 'bell_curve',
    name: 'Bell Curve',
  },
  {
    key: 'split_bell_curve',
    name: 'Split Bell Curve',
  },
  {
    key: 'straight_line',
    name: 'Straight Line',
  },
  {
    key: 'straight_incline',
    name: 'Straight Incline',
  },
  {
    key: 'straight_decline',
    name: 'Straight Decline',
  },
  {
    key: 'manual',
    name: 'Manual',
  },
];

export enum SPEND_DISTRIBUTION_STATE {
  LOADING,
  // SHOW_SPREADSHEET,
  DEFAULT,
}

export const spendTypeKeys = ['monthly_budget', 'monthly_forecast'];

export const MONTHS_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

export const specialCharReplaceRegexp = /[^a-zA-Z0-9 ]/g;

export enum SPEND_TYPES {
  BUDGET = 'Budget',
  BUDGET_PARENT_ONLY = 'Budget Parent Only',
  BUDGET_PARENT_CHILD = 'Budget (P & S)',
  BUDGET_COMMITMENTS = 'Budget & Commitments',
  BUDGET_COMMITMENTS_GC = 'Commitments vs Budget (P & S)',
  COMMITMENTS = 'Commitments',
  PRIME_CONTRACT_PARENT_ONLY = 'Prime Contract (Parent Only)',
  PRIME_CONTRACT_PARENT_CHILD = 'Prime Contract (P & S)',
}
export const getDefaultSpendType = (isManager: boolean) =>
  isManager ? SPEND_TYPES.BUDGET : SPEND_TYPES.BUDGET_PARENT_CHILD;

export enum SPEND_ACTIONS {
  REFRESH,
  OPEN,
  CLOSE,
  SAVE,
  UPDATE,
  CLOSE_SHEETS,
  CHANGE_BUDGET_TYPE,
}

// this is used in spend service
export const MONTH_IS_BEFORE_YEAR = -1;
export const MONTH_IS_AFTER_YEAR = 13;

export const defaultSpendLineSummary: ISpendLineItemSummary = {
  name: '',
  spend_contracts: {
    contracts: [],
    committed: 0,
  },
  spend_direct_costs: {
    direct_costs: [],
    committed: 0,
  },
  committed: 0,
  isLoaded: false,
};

export const DELETE_TEMPLATE_ID = -2;
export const DELETE_TEMPLATE_NAME = 'Delete Budget';

export const DELETE_BUDGET_TEMPLATE = {
  id: DELETE_TEMPLATE_ID,
  name: DELETE_TEMPLATE_NAME,
  template_items: [],
  is_owner: false,
  is_trashed: false,
};
